export default __webpack_public_path__ + "static/media/logo.fb5a4ce9.png";